import {createContext, useContext} from "react";
import {User} from "../types/User";

export class UserSession {
	user: User | null;

	constructor(user: User | null) {
		this.user = user;
	}

}

export const UserSessionContext = createContext<UserSession | null>(null);

export function useUserSession(): UserSession {
	const ctx = useContext(UserSessionContext);
	if (!ctx) throw new Error("useUserSession must be used within App!");
	return ctx;
}

export type UserSessionUpdate = (s: UserSession) => any;

export const UserSessionUpdateContext = createContext<UserSessionUpdate | null>(null);

export function useUserSessionUpdate(): UserSessionUpdate {
	const ctx = useContext(UserSessionUpdateContext);
	if (!ctx) throw new Error("useUserSessionUpdate must be used within App!");
	return ctx;
}

export function useUser(): User {
	const session = useUserSession();
	if (!session.user) throw new Error("useUser must be used within Main!");
	return session.user;
}

export type UserUpdate = (u: User | null) => any;

export function useUserUpdate(): UserUpdate {
	const sessionUpdate = useUserSessionUpdate();
	return (u) => {
		sessionUpdate(new UserSession(u));
	}
}

export function useIsSuperuser(): boolean {
	const session = useUserSession();
	if (!session.user) return false;
	const su = session.user.roles.find((r) => r.internalCode === 'ROLE_SUPERUSER');
	return su !== undefined;
}
